import { useMemo } from 'react';
import { useWixFlowContext } from '../components/WixFlow/WixFlowContext';
export const useMetadata = () => {
  const {
    flowContext
  } = useWixFlowContext();
  const metadata = useMemo(() => (flowContext == null ? void 0 : flowContext.metadata) || {
    biSlug: '',
    language: 'en'
  }, [flowContext == null ? void 0 : flowContext.metadata]);
  return [metadata];
};
//# sourceMappingURL=useMetadata.js.map